import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiState } from '../../../types/api';
import { IRole } from '../../../types/role';
import { RootState } from '../..';

interface IGetRolesResponse {
  status?: boolean;
  message?: string;
  data?: IRole[];
}

const initialState: IApiState<IGetRolesResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const getRolesAsync = createAsyncThunk(
  'roles/get',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;

      const businessId =
        localStorage.getItem('businessId') ||
        state.auth.value?.data?.user?.businesses?.[0]?.id;

      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
          'X-Business-Id': businessId,
        },
      };

      const { data } = await api.get('/roles', config);

      return data;
    } catch (err) {
      const error = err as AxiosError<IGetRolesResponse>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const rolesFetch = createSlice({
  name: 'roles/fetch',
  initialState,
  reducers: {
    resetGetRoles: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRolesAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(getRolesAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IGetRolesResponse;
      })
      .addCase(getRolesAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IGetRolesResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetGetRoles } = rolesFetch.actions;
export default rolesFetch.reducer;
